export default {
    coins: [
        { price: "25", amount: "10", },
        { price: "125", amount: "50", label: "mostPopular" },
        { price: "250", amount: "100" },
        { price: "2500", amount: '1000', label: "bestValue" }
    ],
    items: [
        { price: "60", type: "silverCard", expiration: "30days" },
        { price: "60", type: "goldCard", expiration: "30days" },
        { price: "60", type: "platinumCard", expiration: "30days" },
        { name: "avatars", price: 60 },
        { name: "emojis", price: "430", label: "mostPopular" }
    ],
    sapphires: [
        { price: "$0.99", amount: "60", },
        { price: "$4.99", amount: "360" },
        { price: "$12.99", amount: "930", label: "mostPopular" },
        { price: "$19.99", amount: "1500" },
        { price: "$46.99", amount: "3600" },
        { price: "$99.99", amount: "7700", label: "bestValue" }
    ]
}
